import GiftEditor from './GiftEditor';
export default GiftEditor;
